
import React from 'react';
import { mergeStyleSets } from '@uifabric/merge-styles';
import { Stack } from 'office-ui-fabric-react/lib/Stack';

import useArticles from '../../hooks/useArticles';
import useArticleByName from '../../hooks/useArticleByName';
import useIsArticlesLoaded from '../../hooks/useIsArticlesLoaded';
import IfComp from '../../common/client/components/IfComp';
import AppPageStyle from '../../common/client/components/mysliveckyportal/AppPageStyle';

import useNavigationItems  from '../../hooks/useNavigationItems';
import CheckUserAccountActivation from '../../components/auth/CheckUserAccountActivation';
import Article from '../../components/articles/Article';
import LoginInfo from '../../components/auth/LoginInfo';

const classNames = mergeStyleSets({
    ArticlePage: {
        padding: 16
    },
});

const ArticlePage = (props) => {

    const isArticlesLoaded = useIsArticlesLoaded();
    useArticles();
    const name = props.match?.params?.name;
    const article = useArticleByName(name);
    const navigationItems = useNavigationItems();

    return (
        <AppPageStyle
            appHeaderContent={<LoginInfo />}
            navigationItems={navigationItems}
            page="articles"
        >
            <CheckUserAccountActivation />
            <Stack className={classNames.ArticlePage}>
                <IfComp cond={isArticlesLoaded && article}>
                    <Article article={article} />
                </IfComp>
                <IfComp cond={isArticlesLoaded && !article}>
                    <div>Požadovaný článek nenalezen</div>
                </IfComp>
            </Stack>
        </AppPageStyle>
    );
}

export default ArticlePage;
